import {useQuery} from '@apollo/client';
import {Select} from 'antd';
import {GET_ALL_STOCKS_WITH_INSTRUMENT_KEY} from 'graphql/queries/stocks';

// The exchange list, without the Error members of the union.
export const useExchanges = () => {
  const {data, loading} = useQuery(GET_ALL_STOCKS_WITH_INSTRUMENT_KEY, {
    errorPolicy: 'all',
  });
  const exchanges = (data?.getAllStocksExchange || []).filter(
    item => item?.__typename === 'StockExchange' && item.id,
  );
  return {exchanges, loading};
};

// Selects an exchange by id and shows it by code. `exclude` leaves out the
// given exchange ids. Extra props go to the Select.
const ExchangeSelect = ({value, onChange, placeholder, exclude, ...props}) => {
  const {exchanges, loading} = useExchanges();
  return (
    <Select
      value={value ?? undefined}
      onChange={onChange}
      loading={loading}
      showSearch
      optionFilterProp="label"
      placeholder={placeholder || 'Select exchange'}
      options={exchanges
        .filter(exchange => !exclude?.includes(exchange.id))
        .map(exchange => ({
          value: exchange.id,
          label: exchange.code
            ? `${exchange.code} · ${exchange.stockExchangeName}`
            : exchange.stockExchangeName,
        }))}
      {...props}
    />
  );
};

export default ExchangeSelect;
